import { useEffect, useState } from "react";
import { toast } from "sonner";
import { http, apiError } from "@/lib/api";
import { useAds } from "@/components/news/Ads";

const SLOTS = [
  ["head", "Código no <head>", "Scripts globais: Google AdSense auto-ads, Analytics, Meta Pixel…"],
  ["body_top", "Início do <body>", "Aparece no topo de todas as páginas, antes do cabeçalho."],
  ["header_banner", "Banner topo (página inicial)", "Por baixo do menu, antes do slide."],
  ["home_between", "Entre notícias (página inicial)", "Aparece entre as secções de categorias."],
  ["sidebar", "Barra lateral", "Página inicial e páginas de categoria."],
  ["article_top", "Artigo — antes do texto", "Por baixo da imagem principal da notícia."],
  ["article_inside", "Artigo — dentro do texto", "No meio do conteúdo da notícia."],
  ["article_bottom", "Artigo — fim do texto", "Depois do conteúdo da notícia."],
  ["footer", "Rodapé", "Antes do rodapé, em todas as páginas."],
];

export function AdsManager() {
  const { setAds } = useAds();
  const [slots, setSlots] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { http.get("/ads").then((r) => setSlots(r.data)); }, []);
  const save = async () => {
    setBusy(true);
    try { const { data } = await http.put("/admin/ads", { slots }); setAds(data); toast.success("Anúncios guardados e ativos no site"); }
    catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };
  if (!slots) return <p className="text-muted-foreground">A carregar…</p>;
  return (
    <div data-testid="ads-manager" className="space-y-4">
      <p className="text-sm text-muted-foreground">Cole aqui o código dos seus anúncios (AdSense, Adsterra, banners HTML…). Deixe vazio para desativar o espaço.</p>
      {SLOTS.map(([k, label, hint]) => (
        <div key={k} className="rounded-xl border bg-background p-4">
          <div className="flex items-center justify-between">
            <label className="font-bold" htmlFor={`ad-${k}`}>{label}</label>
            <span className={`rounded-full px-2 py-0.5 text-[10px] font-bold uppercase ${slots[k]?.trim() ? "bg-emerald-500/15 text-emerald-600" : "bg-muted text-muted-foreground"}`}>{slots[k]?.trim() ? "Ativo" : "Vazio"}</span>
          </div>
          <p className="mb-2 text-xs text-muted-foreground">{hint}</p>
          <textarea id={`ad-${k}`} data-testid={`ad-input-${k}`} value={slots[k] || ""} onChange={(e) => setSlots({ ...slots, [k]: e.target.value })} rows={3} spellCheck={false}
            placeholder="<script async src=...></script>" className="w-full rounded-lg border bg-muted/40 p-3 font-mono-meta text-xs outline-none focus:border-primary" />
        </div>
      ))}
      <button data-testid="ads-save-btn" onClick={save} disabled={busy} className="rounded-full bg-primary px-8 py-3 text-sm font-bold text-white disabled:opacity-60">{busy ? "A guardar…" : "Guardar anúncios"}</button>
    </div>
  );
}
